// Navigation helper functions

// Global history object
let historyInstance = null;

// Initialize the history instance
export const initializeHistory = (history) => {
  historyInstance = history;
};

// Navigate to the Payment Required page
export const navigateToPaymentRequired = (type) => {
  const path = type ? `/payment-required?type=${type}` : "/payment-required";
  if (historyInstance) {
    historyInstance.push(path);
  } else {
    window.location.href = path;
  }
};

// Navigate to the Permission Denied page
export const navigateToPermissionDenied = () => {
  if (historyInstance) {
    historyInstance.push("/permission-denied");
  } else {
    window.location.href = "/permission-denied";
  }
};

// Navigate to the Server Error page
export const navigateToServerError = () => {
  if (historyInstance) {
    historyInstance.push("/server-error");
  } else {
    window.location.href = "/server-error";
  }
};
